var CURRENCY_CODES;
(function (CURRENCY_CODES) {
    CURRENCY_CODES["GBP"] = "GBP";
    CURRENCY_CODES["FKP"] = "FKP";
})(CURRENCY_CODES || (CURRENCY_CODES = {}));
export function formatCurrency({ amount, cultureCode, currencyCode, minimumFractionDigits = 0, maximumFractionDigits = 0, }) {
    // TODO : need to bring the parameters from app-config
    const cultureCodeCombined = cultureCode || 'en-gb';
    const currencyCodeCombined = currencyCode || 'GBP';
    if (amount == null) {
        return null;
    }
    return new Intl.NumberFormat(cultureCodeCombined, {
        style: 'currency',
        currency: currencyCodeCombined === CURRENCY_CODES.FKP ? CURRENCY_CODES.GBP : currencyCodeCombined,
        minimumFractionDigits,
        maximumFractionDigits,
    }).format(amount);
}
